const {
    lang: { LANG_ENUM }
} = require('@futuweb/fego-bridge');
const { use } = require('@fegobull/webapi');

// 多语言文本映射
const langTextMap = {
    [LANG_ENUM.CN]: {
        // 加载状态相关
        loading: '加载中...',
        loadFailed: '加载失败',
        notConfigured: '未配置 moduleName',
        // 表单相关
        submitBtn: '提交预约',
        placeholder_activity: '请选择预约项目',
        placeholder_date: '请选择日期',
        placeholder_month: '请选择月份',
        placeholder_day: '请选择日期',
        placeholder_time: '请选择时段',
        placeholder_ext1: '请选择',
        placeholder_ext2: '请选择',
        toast_select_activity_first: '请先选择预约项目',
        toast_select_date_first: '请先选择日期',
        // 预约结果相关
        status_success: '预约成功',
        status_signed: '已签到',
        status_expired: '已过期',
        status_canceled: '已取消',
        status_failed: '预约失败',
        time_slot_full: '已满',
        time_slot_reserved: '已预约',
        label_activity: '预约项目',
        label_time: '时间',
        label_address: '地址',
        btn_invite: '喊朋友一起去',
        btn_add_reservation: '新增预约',
        btn_cancel: '取消预约',
        btn_cancel_disabled: '不可取消',
        btn_reserve_more: '预约更多',
        btn_create_new_reservation: '创建新的预约',
        explore_more: '探索更多',
        btn_view_records: '预约记录',
        cancel_confirm_title: '确定取消预约吗？',
        cancel_confirm_subtitle: '',
        cancel_confirm_ok: '确认',
        cancel_confirm_cancel: '再想想',
        cancel_success: '取消成功',
        cancel_failed: '取消失败',
        no_data: '-',
        // 错误码提示（code → message）
        error_default: '操作失败，请稍后重试',
        error_10001: '活动配置不存在',
        error_10002: '预约时段不存在',
        error_10003: '用户已被禁用',
        error_10004: '预约人数已达上限',
        error_10005: '取消预约失败',
        error_10006: '模块名称不能为空',
        error_10007: '取消时间已过期',
        error_10008: '报名时间已截止'
    },
    [LANG_ENUM.HK]: {
        // 加载状态相关
        loading: '加載中...',
        loadFailed: '加載失敗',
        notConfigured: '未配置 moduleName',
        // 表单相关
        submitBtn: '提交預約',
        placeholder_activity: '請選擇預約項目',
        placeholder_date: '請選擇日期',
        placeholder_month: '請選擇月份',
        placeholder_day: '請選擇日期',
        placeholder_time: '請選擇時段',
        placeholder_ext1: '請選擇',
        placeholder_ext2: '請選擇',
        toast_select_activity_first: '請先選擇預約項目',
        toast_select_date_first: '請先選擇日期',
        // 预约结果相关
        status_success: '預約成功',
        status_signed: '已簽到',
        status_expired: '已過期',
        status_canceled: '已取消',
        status_failed: '預約失敗',
        time_slot_full: '已滿',
        time_slot_reserved: '已預約',
        label_activity: '預約項目',
        label_time: '時間',
        label_address: '地址',
        btn_invite: '喊朋友一起去',
        btn_add_reservation: '新增預約',
        btn_cancel: '取消預約',
        btn_cancel_disabled: '不可取消',
        btn_reserve_more: '預約更多',
        btn_create_new_reservation: '創建新的預約',
        explore_more: '探索更多',
        btn_view_records: '預約記錄',
        cancel_confirm_title: '確定取消預約嗎？',
        cancel_confirm_subtitle: '',
        cancel_confirm_ok: '確認',
        cancel_confirm_cancel: '再想想',
        cancel_success: '取消成功',
        cancel_failed: '取消失敗',
        no_data: '-',
        // 錯誤碼提示（code → message）
        error_default: '操作失敗，請稍後重試',
        error_10001: '活動配置不存在',
        error_10002: '預約時段不存在',
        error_10003: '用戶已被禁用',
        error_10004: '預約人數已達上限',
        error_10005: '取消預約失敗',
        error_10006: '模組名稱不能為空',
        error_10007: '取消時間已過期',
        error_10008: '報名時間已截止'
    },
    [LANG_ENUM.EN]: {
        // 加载状态相关
        loading: 'Loading...',
        loadFailed: 'Load Failed',
        notConfigured: 'moduleName not configured',
        // 表单相关
        submitBtn: 'Submit Reservation',
        placeholder_activity: 'Please select reservation item',
        placeholder_date: 'Please select date',
        placeholder_month: 'Please select month',
        placeholder_day: 'Please select day',
        placeholder_time: 'Please select time slot',
        placeholder_ext1: 'Please select',
        placeholder_ext2: 'Please select',
        toast_select_activity_first: 'Please select reservation item first',
        toast_select_date_first: 'Please select date first',
        // 预约结果相关
        status_success: 'Reservation Successful',
        status_signed: 'Checked In',
        status_expired: 'Expired',
        status_canceled: 'Canceled',
        status_failed: 'Reservation Failed',
        time_slot_full: 'Full',
        time_slot_reserved: 'Reserved',
        label_activity: 'Reservation Item',
        label_time: 'Time',
        label_address: 'Address',
        btn_invite: 'Invite Friends',
        btn_add_reservation: 'Add',
        btn_cancel: 'Cancel',
        btn_cancel_disabled: 'Cannot cancel',
        btn_reserve_more: 'Reserve More',
        btn_create_new_reservation: 'Create New Reservation',
        explore_more: 'Explore More',
        btn_view_records: 'Reservation Records',
        cancel_confirm_title: 'Cancel Reservation?',
        cancel_confirm_subtitle: '',
        cancel_confirm_ok: 'Confirm',
        cancel_confirm_cancel: 'Think Again',
        cancel_success: 'Canceled Successfully',
        cancel_failed: 'Cancel Failed',
        no_data: '-',
        // Error code messages (code → message)
        error_default: 'Operation failed, please try again later',
        error_10001: 'Activity not found',
        error_10002: 'Reservation not found',
        error_10003: 'User is disabled',
        error_10004: 'Reservation limit reached',
        error_10005: 'Cancel reservation failed',
        error_10006: 'Module name is required',
        error_10007: 'Cancel time expired',
        error_10008: 'Registration deadline passed'
    },
    [LANG_ENUM.JA]: {
        // 加载状态相关
        loading: '読み込み中...',
        loadFailed: '読み込み失敗',
        notConfigured: 'moduleNameが設定されていません',
        // 表单相关
        submitBtn: '予約を送信',
        placeholder_activity: '予約項目を選択してください',
        placeholder_date: '日付を選択してください',
        placeholder_month: '月を選択してください',
        placeholder_day: '日を選択してください',
        placeholder_time: '時間帯を選択してください',
        placeholder_ext1: '選択してください',
        placeholder_ext2: '選択してください',
        toast_select_activity_first: '先に予約項目を選択してください',
        toast_select_date_first: '先に日付を選択してください',
        // 预约结果相关
        status_success: '予約完了',
        status_signed: 'チェックイン済み',
        status_expired: '期限切れ',
        status_canceled: 'キャンセル済み',
        status_failed: '予約失敗',
        time_slot_full: '満員',
        time_slot_reserved: '予約済み',
        label_activity: '予約項目',
        label_time: '時間',
        label_address: '住所',
        btn_invite: '友達を誘う',
        btn_add_reservation: '新規予約',
        btn_cancel: '予約をキャンセル',
        btn_cancel_disabled: 'キャンセルできません',
        btn_reserve_more: 'さらに予約',
        btn_create_new_reservation: '新しい予約を作成',
        explore_more: 'もっと探す',
        btn_view_records: '予約履歴',
        cancel_confirm_title: '予約をキャンセルしますか？',
        cancel_confirm_subtitle: '',
        cancel_confirm_ok: '確認',
        cancel_confirm_cancel: 'もう一度考える',
        cancel_success: 'キャンセル成功',
        cancel_failed: 'キャンセル失敗',
        no_data: '-',
        // エラーコードメッセージ（code → message）
        error_default: '操作に失敗しました，後でもう一度お試しください',
        error_10001: 'アクティビティが見つかりません',
        error_10002: '予約時間帯が見つかりません',
        error_10003: 'ユーザーは無効です',
        error_10004: '予約人数が上限に達しました',
        error_10005: '予約のキャンセルに失敗しました',
        error_10006: 'モジュール名が必要です',
        error_10007: 'キャンセル期限が過ぎています',
        error_10008: '申し込み期限が過ぎています'
    }
};

const $t = use.useI18n(langTextMap);
export default $t;
